import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageScaffold from '../../components/layout/page-scaffold';
import { useAuth } from '../../hooks/use-auth';
import Hero from './components/hero';
import Empathy from './components/empathy';
import LpBenefits from './components/lp-benefits';
import Features from './components/features';
import HowItWorks from './components/how-it-works';
import Operations from './components/operations';
import UseCases from './components/use-cases';
import Faq from './components/faq';
import FinalCta from './components/final-cta';

export default function HomePage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      navigate('/app', { replace: true });
    }
  }, [loading, user, navigate]);

  return (
    <PageScaffold mainClassName="pt-0" transparentNavAtTop>
      <Hero />
      <Empathy />
      <LpBenefits />
      <Features />
      <HowItWorks />
      <Operations />
      <UseCases />
      <Faq />
      <FinalCta />
    </PageScaffold>
  );
}
